import { render, staticRenderFns } from "./ChromatogramLive.vue?vue&type=template&id=55870abd&scoped=true&"
import script from "./ChromatogramLive.vue?vue&type=script&lang=js&"
export * from "./ChromatogramLive.vue?vue&type=script&lang=js&"
import style0 from "./ChromatogramLive.vue?vue&type=style&index=0&id=55870abd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55870abd",
  null
  
)

export default component.exports